import { property } from 'lit/decorators.js';
import { CrntButtonAlt } from '../button-alt/button-alt.component.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntIconButtonAlt extends CrntButtonAlt {
  constructor() {
    super();
    this.state = "enabled";
    this.iconOnly = true;
  }
  static {
    this.tagName = "crnt-icon-button-alt";
  }
}
__decorateClass([
  property({ reflect: true })
], CrntIconButtonAlt.prototype, "state");

export { CrntIconButtonAlt };
